import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Tabs } from './Tabs';
import { TopBar } from './TopBar';
import { VerificationBanner } from './VerificationBanner';
import { SessionProvider, useSession } from '~/lib/session-context';

/**
 * Authed-layout wrapper. SessionProvider calls /dashboard/me on mount; the
 * inner guard waits for that response rather than peeking at any client-side
 * token, because the session is now an HttpOnly cookie we can't read. A 401
 * leaves me=null and routes to /login.
 */
export function Shell(): JSX.Element {
  return (
    <SessionProvider>
      <AuthedChrome />
    </SessionProvider>
  );
}

function AuthedChrome(): JSX.Element {
  const location = useLocation();
  const { me, loading } = useSession();

  if (loading) {
    // A near-invisible hold so a signed-in reload doesn't flash the login
    // page before /dashboard/me resolves. One or two frames in practice.
    return <div className="min-h-full bg-surface-canvas" aria-hidden />;
  }
  if (!me) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return (
    <div className="flex min-h-full flex-col">
      <TopBar />
      <Tabs />
      <VerificationBanner />
      <Outlet />
    </div>
  );
}
